<template>
	<tr
		:class="{ 'table-secondary text-muted': voce.FLG_DA_CALCOLARE == 0, 'table-danger text-muted': voce.FLG_ELIMINATO == 1, 'fuori-preventivo': voce.FUORI_PREVENTIVO }"
		:style="voce.COLORE && voce.FLG_ELIMINATO != 1 ? { backgroundColor: voce.COLORE, color: voce.COLORE_TESTO || utils.getContrastColor(voce.COLORE) } : {}"
	>
		<!-- Colonna # (ordine) -->
		<td v-if="!$root.isMobile" class="table-head-sm text-center voce-cell voce-cell-index" data-width="3%;">
			<input v-if="!readOnly" type="checkbox" class="me-1" :checked="voce.SELEZIONATO == 1" @click.stop @change="filters.selectTree([voce], $event.target.checked ? 1 : 0)">
			<i v-if="dragEnabled" class="ph-dots-six-vertical drag-handle-voce cursor-move" :title="$root.translate('dizionario.attivita.TRASCINA_SPOSTA_VOCE')" @click.stop></i>
			<small v-else>{{ voce.ORDINE }}</small>
		</td>

		<!-- ===== DESKTOP: colonne classiche ===== -->
		<template v-if="!$root.isMobile">
			<!-- GRUPPO VENDITA -->
			<td class="table-head-sm voce-cell voce-cell-vendita" style="word-wrap: break-word; white-space: normal; border-left: 1px solid #e8e8e8; border-right: 1px solid #e8e8e8;">
				<div class="d-flex align-items-center" :style="{ marginLeft: '8px' }">
					<i
						class="ph-file-text me-1 flex-shrink-0"
						:class="isTitleTruncated ? 'text-warning' : 'text-muted'"
						:style="{ cursor: isTitleTruncated ? 'pointer' : 'default' }"
						@click.stop="isTitleTruncated && (titleExpanded = !titleExpanded)"
					></i><span ref="titolo" class="voce-titolo-html" :class="titleExpanded ? 'is-expanded' : 'is-collapsed'" style="min-width:0;" v-html="titoloVoceHtml"></span>
					<span v-if="voce.FLG_DA_CALCOLARE == 0" class="badge bg-secondary ms-1 flex-shrink-0" style="font-size:0.6rem;"><Translate :path="'dizionario.attivita.ESCLUSA'"></Translate></span><span v-if="voce.FUORI_PREVENTIVO && voce.FLG_CONSUNTIVO == 1" class="badge bg-warning ms-1 flex-shrink-0" style="font-size:0.6rem;" :title="$root.translate('dizionario.attivita.FUORI_PREVENTIVO_INFO')"><Translate :path="'dizionario.attivita.CONSUNTIVO'"></Translate></span>
				</div>
			</td>
			<td class="table-head-sm text-end voce-cell voce-cell-vendita" style="border-left: 1px solid #e8e8e8; border-right: 1px solid #e8e8e8;" data-width="6%;"
				:class="{ 'inline-editable': canEditInline }"
				@dblclick="startEditCampo('QUANTITY_PRICE', parseFloat(voce.QUANTITY_PRICE))">
				<input v-if="editingField == 'QUANTITY_PRICE'" ref="inlineInput" type="number" step="1" class="form-control form-control-sm inline-edit-input"
					v-model="editingValue" @blur="confermaEditCampo" @keyup.enter="confermaEditCampo" @keyup.esc="annullaEditCampo">
				<template v-else>{{ parseFloat(voce.QUANTITY_PRICE) }}</template>
			</td>
			<td class="table-head-sm text-end voce-cell voce-cell-vendita" style="border-left: 1px solid #e8e8e8; border-right: 1px solid #e8e8e8;" data-width="6%;"
				:class="{ 'inline-editable': canEditInline }"
				@dblclick="startEditCampo('DAYS_PRICE', parseFloat(voce.DAYS_PRICE))">
				<input v-if="editingField == 'DAYS_PRICE'" ref="inlineInput" type="number" step="1" class="form-control form-control-sm inline-edit-input"
					v-model="editingValue" @blur="confermaEditCampo" @keyup.enter="confermaEditCampo" @keyup.esc="annullaEditCampo">
				<template v-else>{{ parseFloat(voce.DAYS_PRICE) }}</template>
			</td>
			<td class="table-head-sm text-end voce-cell voce-cell-vendita" style="border-left: 1px solid #e8e8e8; border-right: 1px solid #e8e8e8;" data-width="9%;"
				:class="{ 'inline-editable': canEditInline && voce.FLG_OMAGGIO_UNIT_PRICE != 1 }"
				@dblclick="startEditCampo('UNIT_PRICE', parseFloat(voce.UNIT_PRICE), voce.FLG_OMAGGIO_UNIT_PRICE == 1)">
				<input v-if="editingField == 'UNIT_PRICE'" ref="inlineInput" type="number" step="0.01" class="form-control form-control-sm inline-edit-input"
					v-model="editingValue" @blur="confermaEditCampo" @keyup.enter="confermaEditCampo" @keyup.esc="annullaEditCampo">
				<template v-else-if="voce.FLG_OMAGGIO_UNIT_PRICE == 1">
					<span class="badge bg-primary bg-opacity-20 text-primary" style="font-size:0.65rem;"><Translate :path="'dizionario.attivita.OMAGGIO'"></Translate></span>
				</template>
				<template v-else>
					<span class="text-muted" style="font-size:0.75rem;">&euro; {{ filters.formattaImporto(voce.UNIT_PRICE) }}</span>
				</template>
			</td>
			<td class="table-head-sm text-end voce-cell voce-cell-vendita" style="border-left: 1px solid #e8e8e8; border-right: 20px solid white !important;" data-width="9%;">
				<span v-if="voce.FLG_ESCLUDI_TOTALE_VENDITA == 1" class="text-muted" title="Non sommata nei totali">-</span>
				<template v-else-if="voce.FLG_OMAGGIO_UNIT_PRICE == 1 || voce.FLG_OMAGGIO_TOTAL_PRICE == 1">
					<span class="badge bg-primary bg-opacity-20 text-primary" style="font-size:0.65rem;"><Translate :path="'dizionario.attivita.OMAGGIO'"></Translate></span>
				</template>
				<template v-else>
					<span class="text-primary fs-sm fw-semibold">&euro; {{ filters.formattaImporto(totalePrezzoMostrato) }}</span>
					<span v-if="ivaCode"
						class="badge bg-secondary ms-1"
						style="font-size:0.65rem;"
						:title="ivaCode.DESCRIZIONE">
						{{ ivaCode.CUSTOM_1 }}
					</span>
				</template>
			</td>

			<!-- GRUPPO ACQUISTO -->
			<td class="table-head-sm text-end voce-cell voce-cell-acquisto" style="border-left: 20px solid white !important; border-right: 1px solid #FFD648;" data-width="7%;"
				:class="{ 'inline-editable': canEditInline && voce.FLG_OMAGGIO_UNIT_COST_ESPOSTO != 1 }"
				@dblclick="startEditCampo('UNIT_COST_ESPOSTO', parseFloat(voce.UNIT_COST_ESPOSTO), voce.FLG_OMAGGIO_UNIT_COST_ESPOSTO == 1)">
				<input v-if="editingField == 'UNIT_COST_ESPOSTO'" ref="inlineInput" type="number" step="0.01" class="form-control form-control-sm inline-edit-input"
					v-model="editingValue" @blur="confermaEditCampo" @keyup.enter="confermaEditCampo" @keyup.esc="annullaEditCampo">
				<template v-else-if="voce.FLG_OMAGGIO_UNIT_COST_ESPOSTO == 1">
					<span class="badge bg-danger bg-opacity-20 text-danger" style="font-size:0.65rem;"><Translate :path="'dizionario.attivita.OMAGGIO'"></Translate></span>
				</template>
				<template v-else>
					<span class="text-muted" style="font-size:0.75rem;">&euro; {{ filters.formattaImporto(voce.UNIT_COST_ESPOSTO) }}</span>
				</template>
			</td>
			<td class="table-head-sm text-end voce-cell voce-cell-acquisto" style="border-left: 1px solid #FFD648; border-right: 1px solid #FFD648;" data-width="7%;">
				<span v-if="voce.FLG_ESCLUDI_TOTALE_ACQUISTO == 1" class="text-muted" title="Non sommata nei totali">-</span>
				<template v-else-if="voce.FLG_OMAGGIO_UNIT_COST_ESPOSTO == 1">
					<span class="badge bg-danger bg-opacity-20 text-danger" style="font-size:0.65rem;"><Translate :path="'dizionario.attivita.OMAGGIO'"></Translate></span>
				</template>
				<template v-else>
					<span class="text-danger fs-sm fw-semibold">&euro; {{ filters.formattaImporto(totaleCostoMostrato) }}</span>
					<span v-if="ivaCodiceAcquisto"
						class="badge bg-secondary ms-1"
						style="font-size:0.65rem;"
						:title="ivaCodiceAcquisto.DESCRIZIONE">
						{{ ivaCodiceAcquisto.CUSTOM_1 }}
					</span>
				</template>
			</td>
			<td class="table-head-sm text-end voce-cell voce-cell-acquisto" style="border-left: 1px solid #FFD648; border-right: 1px solid #FFD648;" data-width="7%;"
				:class="{ 'inline-editable': canEditInline && voce.FLG_OMAGGIO_TOTAL_COST_PRIVATO != 1 }"
				@dblclick="startEditCampo('TOTAL_COST_PRIVATO', parseFloat(voce.TOTAL_COST_PRIVATO), voce.FLG_OMAGGIO_TOTAL_COST_PRIVATO == 1)">
				<input v-if="editingField == 'TOTAL_COST_PRIVATO'" ref="inlineInput" type="number" step="0.01" class="form-control form-control-sm inline-edit-input"
					v-model="editingValue" @blur="confermaEditCampo" @keyup.enter="confermaEditCampo" @keyup.esc="annullaEditCampo">
				<span v-else-if="voce.FLG_ESCLUDI_TOTALE_ACQUISTO == 1" class="text-muted" title="Non sommata nei totali">-</span>
				<template v-else-if="voce.FLG_OMAGGIO_TOTAL_COST_PRIVATO == 1">
					<span class="badge bg-warning bg-opacity-20 text-warning" style="font-size:0.65rem;"><Translate :path="'dizionario.attivita.OMAGGIO'"></Translate></span>
				</template>
				<template v-else>
					<span class="text-warning fs-sm fw-semibold">&euro; {{ filters.formattaImporto(totaleCommissioniMostrato) }}</span>
					<span v-if="ivaCodiceCommissioni"
						class="badge bg-secondary ms-1"
						style="font-size:0.65rem;"
						:title="ivaCodiceCommissioni.DESCRIZIONE">
						{{ ivaCodiceCommissioni.CUSTOM_1 }}
					</span>
				</template>
			</td>
			<td class="table-head-sm text-end voce-cell voce-cell-fornitore" style="border-left: 1px solid #FFD648; border-right: 1px solid #FFD648;" data-width="15%;">
				<span v-if="voce.FORNITORE_ALIAS" class="text-muted" style="font-size: 11px; text-transform: uppercase; color: rgb(113, 128, 150); font-weight: 700; margin-bottom: 6px; display: block; letter-spacing: 0.5px;">{{ filters.accorciaTesto(voce.FORNITORE_ALIAS, 50) }}<span v-if="voce.IMPORTO_FATTURATO > 0" class="badge ms-1" style="font-size:0.65rem; letter-spacing:0;" :class="percFatturata >= 100 ? 'bg-success' : 'bg-warning text-dark'" :title="'Fatturato € ' + filters.formattaImporto(voce.IMPORTO_FATTURATO) + ' su € ' + filters.formattaImporto(importoAcquisto)">F {{ percFatturata }}%</span></span>
				<span v-else class="text-muted fst-italic" style="font-size:0.7rem;">-</span>
			</td>

			<!-- Colonna Azioni -->
			<td v-if="!readOnly" class="td-class text-center voce-cell voce-cell-actions actions-cell" data-width="9%;">
				<div class="d-flex align-items-center justify-content-center">
					<div v-if="!dragEnabled" class="dropdown" ref="dropdownEl">
						<a
							href="#"
							class="text-body p-0 ms-1"
							@click.prevent="toggleDropdown"
							:aria-expanded="dropdownOpen"
							:title="$root.translate('dizionario.base.AZIONI')"
							ref="dropdownToggle"
						>
							<i class="ph-list"></i>
						</a>

						<!-- Teleport il menu dropdown fuori dalla gerarchia ricorsiva -->
						<Teleport to="body">
							<div
								v-if="dropdownOpen"
								class="dropdown-menu dropdown-menu-end show"
								:style="dropdownStyle"
								@click="handleMenuClick"
							>
								<a href="#" class="dropdown-item" v-if="$root.hasFunzionalita('VOCE_UPDATE')" @click.prevent="$emit('apri-azioni-voce', { azione: 'modifica', voce, attivita }); closeDropdown()">
									<i class="far fa-edit fa-fw me-2"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.base.BTN_MODIFICA'"></Translate>
								</a>
								<a href="#" class="dropdown-item" v-if="$root.hasFunzionalita('VOCE_CREATE')" @click.prevent="$emit('apri-azioni-voce', { azione: 'aggiungi-preferito', voce, attivita }); closeDropdown()">
									<i class="far fa-star fa-fw me-2"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.attivita.AGGIUNGI_PREFERITI'"></Translate>
								</a>
								<a href="#" class="dropdown-item" @click.prevent="$emit('apri-azioni-voce', { azione: 'allegati', voce, attivita }); closeDropdown()">
									<i class="fas fa-paperclip fa-fw me-2"></i><span class="text-muted me-1">|</span>Allegati
								</a>
								<a href="#" class="dropdown-item" v-if="voce.FK_ID_AZIENDA_FORNITORE > 0 && $root.hasFunzionalita('COSTI_CREATE')" @click.prevent="$emit('apri-azioni-voce', { azione: 'fattura', voce, attivita }); closeDropdown()">
									<i class="far fa-file-invoice fa-fw me-2"></i><span class="text-muted me-1">|</span>Associa a fattura
								</a>
								<a href="#" class="dropdown-item" v-if="voce.FK_ID_ATTIVITA > 0 && (!voce.IN_CONSUNTIVO || voce.FLG_CONSUNTIVO == 1) && $root.hasFunzionalita('VOCE_UPDATE')" @click.prevent="$emit('apri-azioni-voce', { azione: 'consuntivo', voce, attivita }); closeDropdown()">
									<i class="far fa-exchange fa-fw me-2"></i><span class="text-muted me-1">|</span>{{ $root.translate(voce.FLG_CONSUNTIVO == 1 ? 'dizionario.attivita.RIPORTA_PREVENTIVO' : 'dizionario.attivita.SPOSTA_CONSUNTIVO') }}
								</a>
								<a href="#" class="dropdown-item" v-if="!voce.IN_CONSUNTIVO && $root.hasFunzionalita('PROGETTO_UPDATE')" @click.prevent="$emit('apri-azioni-voce', { azione: 'storna', voce, attivita }); closeDropdown()">
									<i class="far fa-minus-circle fa-fw me-2"></i><span class="text-muted me-1">|</span>{{ $root.translate('dizionario.attivita.STORNA_VOCE') }}
								</a>
								<a href="#" class="dropdown-item" v-if="$root.isGod" @click.prevent="toggleFlgAttivoVoce(voce.FLG_ATTIVO_VOCE == 1 ? 0 : 1); closeDropdown()">
									<i :class="voce.FLG_ATTIVO_VOCE == 1 ? 'far fa-times-circle' : 'far fa-check-circle'" class="fa-fw me-2"></i><span class="text-muted me-1">|</span>{{ $root.translate(voce.FLG_ATTIVO_VOCE == 1 ? 'dizionario.base.BTN_DISATTIVA' : 'dizionario.base.BTN_ATTIVA') }}
								</a>
								<div class="dropdown-divider" v-if="$root.isGod"></div>
								<a href="#" class="dropdown-item text-danger" v-if="voce.FLG_ELIMINATO != 1 && $root.hasFunzionalita('VOCE_DELETE')" @click.prevent="$emit('apri-azioni-voce', { azione: 'elimina', voce, attivita }); closeDropdown()">
									<i class="far fa-trash-alt fa-fw me-2"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.base.BTN_ELIMINA'"></Translate>
								</a>
								<a href="#" class="dropdown-item text-danger" v-if="$root.isGod && voce.FLG_ELIMINATO == 1" @click.prevent="$emit('apri-azioni-voce', { azione: 'elimina-definitivamente', voce, attivita }); closeDropdown()">
									<i class="far fa-trash fa-fw me-2"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.base.BTN_ELIMINA_DEF'"></Translate>
								</a>
								<a href="#" class="dropdown-item text-success" v-if="$root.isGod && voce.FLG_ELIMINATO == 1" @click.prevent="$emit('apri-azioni-voce', { azione: 'ripristina', voce, attivita }); closeDropdown()">
									<i class="far fa-redo fa-fw me-2"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.base.BTN_RIPRISTINA'"></Translate>
								</a>
							</div>
						</Teleport>
					</div>
				</div>
			</td>
			<td v-else class="voce-cell voce-cell-actions" data-width="9%;"></td>
		</template>

		<!-- ===== MOBILE: card compatta con dettagli espandibili ===== -->
		<template v-else>
			<td colspan="11" class="p-0 voce-mobile-cell">
				<div class="voce-mobile-row" :style="voce.COLORE ? { backgroundColor: voce.COLORE, color: voce.COLORE_TESTO || utils.getContrastColor(voce.COLORE) } : {}" @click="mobileDetailExpanded = !mobileDetailExpanded">
					<div class="d-flex align-items-center p-2" :class="{ 'flex-wrap': titleExpanded && isTitleTruncated }">
						<div class="d-flex align-items-center" :class="(titleExpanded && isTitleTruncated) ? 'w-100' : 'flex-grow-1 min-w-0'">
							<i
								class="ph-file-text me-1 flex-shrink-0"
								:class="isTitleTruncated ? 'text-warning' : 'text-muted'"
								:style="{ cursor: isTitleTruncated ? 'pointer' : 'default' }"
								@click.stop="isTitleTruncated && (titleExpanded = !titleExpanded)"
							></i>
							<span ref="titolo" class="voce-titolo-html" :class="(titleExpanded && isTitleTruncated) ? 'is-expanded' : 'is-collapsed'" style="min-width:0;" v-html="titoloVoceHtml"></span>
							<span v-if="voce.FLG_DA_CALCOLARE == 0" class="badge bg-secondary ms-1 flex-shrink-0" style="font-size:0.6rem;"><Translate :path="'dizionario.attivita.ESCLUSA'"></Translate></span><span v-if="voce.FUORI_PREVENTIVO && voce.FLG_CONSUNTIVO == 1" class="badge bg-warning ms-1 flex-shrink-0" style="font-size:0.6rem;" :title="$root.translate('dizionario.attivita.FUORI_PREVENTIVO_INFO')"><Translate :path="'dizionario.attivita.CONSUNTIVO'"></Translate></span>
						</div>
						<div v-if="titleExpanded && isTitleTruncated" class="d-flex align-items-center justify-content-between w-100 mt-1">
							<div class="d-flex align-items-center">
								<span class="badge bg-primary bg-opacity-20 text-primary me-1" style="font-size:0.7rem;">&euro; {{ filters.formattaImporto(totalePrezzoMostrato) }}</span>
								<span class="badge bg-danger bg-opacity-20 text-danger" style="font-size:0.7rem;">&euro; {{ filters.formattaImporto(totaleCostoMostrato) }}</span>
							</div>
							<div class="d-flex align-items-center">
								<i v-if="dragEnabled" class="ph-dots-six-vertical drag-handle-voce cursor-move ms-2" :title="$root.translate('dizionario.attivita.TRASCINA_SPOSTA_VOCE')" @click.stop></i>
								<div v-if="!readOnly && !dragEnabled" class="dropdown ms-2" ref="dropdownEl" @click.stop>
									<a
										href="#"
										class="text-body p-0"
										@click.prevent="toggleDropdown"
										:aria-expanded="dropdownOpen"
										:title="$root.translate('dizionario.base.AZIONI')"
										ref="dropdownToggle"
									>
										<i class="ph-list"></i>
									</a>

									<Teleport to="body">
										<div
											v-if="dropdownOpen"
											class="dropdown-menu dropdown-menu-end show"
											:style="dropdownStyle"
											@click="handleMenuClick"
										>
											<a href="#" class="dropdown-item" v-if="$root.hasFunzionalita('VOCE_UPDATE')" @click.prevent="$emit('apri-azioni-voce', { azione: 'modifica', voce, attivita }); closeDropdown()">
												<i class="far fa-edit fa-fw me-2"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.base.BTN_MODIFICA'"></Translate>
											</a>
											<a href="#" class="dropdown-item" v-if="$root.hasFunzionalita('VOCE_CREATE')" @click.prevent="$emit('apri-azioni-voce', { azione: 'aggiungi-preferito', voce, attivita }); closeDropdown()">
												<i class="far fa-star fa-fw me-2"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.attivita.AGGIUNGI_PREFERITI'"></Translate>
											</a>
											<a href="#" class="dropdown-item" @click.prevent="$emit('apri-azioni-voce', { azione: 'allegati', voce, attivita }); closeDropdown()">
												<i class="fas fa-paperclip fa-fw me-2"></i><span class="text-muted me-1">|</span>Allegati
											</a>
											<a href="#" class="dropdown-item" v-if="voce.FK_ID_AZIENDA_FORNITORE > 0 && $root.hasFunzionalita('COSTI_CREATE')" @click.prevent="$emit('apri-azioni-voce', { azione: 'fattura', voce, attivita }); closeDropdown()">
												<i class="far fa-file-invoice fa-fw me-2"></i><span class="text-muted me-1">|</span>Associa a fattura
											</a>
											<a href="#" class="dropdown-item" v-if="voce.FK_ID_ATTIVITA > 0 && (!voce.IN_CONSUNTIVO || voce.FLG_CONSUNTIVO == 1) && $root.hasFunzionalita('VOCE_UPDATE')" @click.prevent="$emit('apri-azioni-voce', { azione: 'consuntivo', voce, attivita }); closeDropdown()">
												<i class="far fa-exchange fa-fw me-2"></i><span class="text-muted me-1">|</span>{{ $root.translate(voce.FLG_CONSUNTIVO == 1 ? 'dizionario.attivita.RIPORTA_PREVENTIVO' : 'dizionario.attivita.SPOSTA_CONSUNTIVO') }}
											</a>
											<a href="#" class="dropdown-item" v-if="!voce.IN_CONSUNTIVO && $root.hasFunzionalita('PROGETTO_UPDATE')" @click.prevent="$emit('apri-azioni-voce', { azione: 'storna', voce, attivita }); closeDropdown()">
												<i class="far fa-minus-circle fa-fw me-2"></i><span class="text-muted me-1">|</span>{{ $root.translate('dizionario.attivita.STORNA_VOCE') }}
											</a>
											<a href="#" class="dropdown-item" v-if="$root.isGod" @click.prevent="toggleFlgAttivoVoce(voce.FLG_ATTIVO_VOCE == 1 ? 0 : 1); closeDropdown()">
												<i :class="voce.FLG_ATTIVO_VOCE == 1 ? 'far fa-times-circle' : 'far fa-check-circle'" class="fa-fw me-2"></i><span class="text-muted me-1">|</span>{{ $root.translate(voce.FLG_ATTIVO_VOCE == 1 ? 'dizionario.base.BTN_DISATTIVA' : 'dizionario.base.BTN_ATTIVA') }}
											</a>
											<div class="dropdown-divider" v-if="$root.isGod"></div>
											<a href="#" class="dropdown-item text-danger" v-if="voce.FLG_ELIMINATO != 1 && $root.hasFunzionalita('VOCE_DELETE')" @click.prevent="$emit('apri-azioni-voce', { azione: 'elimina', voce, attivita }); closeDropdown()">
												<i class="far fa-trash-alt fa-fw me-2"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.base.BTN_ELIMINA'"></Translate>
											</a>
											<a href="#" class="dropdown-item text-danger" v-if="$root.isGod && voce.FLG_ELIMINATO == 1" @click.prevent="$emit('apri-azioni-voce', { azione: 'elimina-definitivamente', voce, attivita }); closeDropdown()">
												<i class="far fa-trash fa-fw me-2"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.base.BTN_ELIMINA_DEF'"></Translate>
											</a>
											<a href="#" class="dropdown-item text-success" v-if="$root.isGod && voce.FLG_ELIMINATO == 1" @click.prevent="$emit('apri-azioni-voce', { azione: 'ripristina', voce, attivita }); closeDropdown()">
												<i class="far fa-redo fa-fw me-2"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.base.BTN_RIPRISTINA'"></Translate>
											</a>
										</div>
									</Teleport>
								</div>
							</div>
						</div>
						<div v-else class="d-flex align-items-center flex-shrink-0 ms-2">
							<span class="badge bg-primary bg-opacity-20 text-primary me-1" style="font-size:0.7rem;">&euro; {{ filters.formattaImporto(totalePrezzoMostrato) }}</span>
							<span class="badge bg-danger bg-opacity-20 text-danger" style="font-size:0.7rem;">&euro; {{ filters.formattaImporto(totaleCostoMostrato) }}</span>
							<i v-if="dragEnabled" class="ph-dots-six-vertical drag-handle-voce cursor-move ms-2" :title="$root.translate('dizionario.attivita.TRASCINA_SPOSTA_VOCE')" @click.stop></i>
							<div v-if="!readOnly && !dragEnabled" class="dropdown ms-2" ref="dropdownEl" @click.stop>
								<a
									href="#"
									class="text-body p-0"
									@click.prevent="toggleDropdown"
									:aria-expanded="dropdownOpen"
									:title="$root.translate('dizionario.base.AZIONI')"
									ref="dropdownToggle"
								>
									<i class="ph-list"></i>
								</a>

								<Teleport to="body">
									<div
										v-if="dropdownOpen"
										class="dropdown-menu dropdown-menu-end show"
										:style="dropdownStyle"
										@click="handleMenuClick"
									>
										<a href="#" class="dropdown-item" v-if="$root.hasFunzionalita('VOCE_UPDATE')" @click.prevent="$emit('apri-azioni-voce', { azione: 'modifica', voce, attivita }); closeDropdown()">
											<i class="far fa-edit fa-fw me-2"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.base.BTN_MODIFICA'"></Translate>
										</a>
										<a href="#" class="dropdown-item" v-if="$root.hasFunzionalita('VOCE_CREATE')" @click.prevent="$emit('apri-azioni-voce', { azione: 'aggiungi-preferito', voce, attivita }); closeDropdown()">
											<i class="far fa-star fa-fw me-2"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.attivita.AGGIUNGI_PREFERITI'"></Translate>
										</a>
										<a href="#" class="dropdown-item" @click.prevent="$emit('apri-azioni-voce', { azione: 'allegati', voce, attivita }); closeDropdown()">
											<i class="fas fa-paperclip fa-fw me-2"></i><span class="text-muted me-1">|</span>Allegati
										</a>
										<a href="#" class="dropdown-item" v-if="voce.FK_ID_AZIENDA_FORNITORE > 0 && $root.hasFunzionalita('COSTI_CREATE')" @click.prevent="$emit('apri-azioni-voce', { azione: 'fattura', voce, attivita }); closeDropdown()">
											<i class="far fa-file-invoice fa-fw me-2"></i><span class="text-muted me-1">|</span>Associa a fattura
										</a>
										<a href="#" class="dropdown-item" v-if="voce.FK_ID_ATTIVITA > 0 && (!voce.IN_CONSUNTIVO || voce.FLG_CONSUNTIVO == 1) && $root.hasFunzionalita('VOCE_UPDATE')" @click.prevent="$emit('apri-azioni-voce', { azione: 'consuntivo', voce, attivita }); closeDropdown()">
											<i class="far fa-exchange fa-fw me-2"></i><span class="text-muted me-1">|</span>{{ $root.translate(voce.FLG_CONSUNTIVO == 1 ? 'dizionario.attivita.RIPORTA_PREVENTIVO' : 'dizionario.attivita.SPOSTA_CONSUNTIVO') }}
										</a>
										<a href="#" class="dropdown-item" v-if="!voce.IN_CONSUNTIVO && $root.hasFunzionalita('PROGETTO_UPDATE')" @click.prevent="$emit('apri-azioni-voce', { azione: 'storna', voce, attivita }); closeDropdown()">
											<i class="far fa-minus-circle fa-fw me-2"></i><span class="text-muted me-1">|</span>{{ $root.translate('dizionario.attivita.STORNA_VOCE') }}
										</a>
										<a href="#" class="dropdown-item" v-if="$root.isGod" @click.prevent="toggleFlgAttivoVoce(voce.FLG_ATTIVO_VOCE == 1 ? 0 : 1); closeDropdown()">
											<i :class="voce.FLG_ATTIVO_VOCE == 1 ? 'far fa-times-circle' : 'far fa-check-circle'" class="fa-fw me-2"></i><span class="text-muted me-1">|</span>{{ $root.translate(voce.FLG_ATTIVO_VOCE == 1 ? 'dizionario.base.BTN_DISATTIVA' : 'dizionario.base.BTN_ATTIVA') }}
										</a>
										<div class="dropdown-divider" v-if="$root.isGod"></div>
										<a href="#" class="dropdown-item text-danger" v-if="voce.FLG_ELIMINATO != 1 && $root.hasFunzionalita('VOCE_DELETE')" @click.prevent="$emit('apri-azioni-voce', { azione: 'elimina', voce, attivita }); closeDropdown()">
											<i class="far fa-trash-alt fa-fw me-2"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.base.BTN_ELIMINA'"></Translate>
										</a>
										<a href="#" class="dropdown-item text-danger" v-if="$root.isGod && voce.FLG_ELIMINATO == 1" @click.prevent="$emit('apri-azioni-voce', { azione: 'elimina-definitivamente', voce, attivita }); closeDropdown()">
											<i class="far fa-trash fa-fw me-2"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.base.BTN_ELIMINA_DEF'"></Translate>
										</a>
										<a href="#" class="dropdown-item text-success" v-if="$root.isGod && voce.FLG_ELIMINATO == 1" @click.prevent="$emit('apri-azioni-voce', { azione: 'ripristina', voce, attivita }); closeDropdown()">
											<i class="far fa-redo fa-fw me-2"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.base.BTN_RIPRISTINA'"></Translate>
										</a>
									</div>
								</Teleport>
							</div>
						</div>
					</div>

					<div v-if="mobileDetailExpanded" class="voce-mobile-details p-2 pt-0" @click.stop>
						<div class="row g-2">
							<div class="col-6">
								<small class="text-muted d-block"><Translate :path="'dizionario.attivita.QUANTITA'"></Translate></small>
								{{ parseFloat(voce.QUANTITY_PRICE) }}
							</div>
							<div class="col-6">
								<small class="text-muted d-block"><Translate :path="'dizionario.attivita.GIORNI'"></Translate></small>
								{{ parseFloat(voce.DAYS_PRICE) }}
							</div>
							<div class="col-6">
								<small class="text-muted d-block"><Translate :path="'dizionario.attivita.PREZZO_UNIT'"></Translate></small>
								<span v-if="voce.FLG_OMAGGIO_UNIT_PRICE == 1" class="badge bg-primary bg-opacity-20 text-primary" style="font-size:0.65rem;"><Translate :path="'dizionario.attivita.OMAGGIO'"></Translate></span>
								<span v-else>&euro; {{ filters.formattaImporto(voce.UNIT_PRICE) }}</span>
							</div>
							<div class="col-6">
								<small class="text-muted d-block"><Translate :path="'dizionario.attivita.TOTALE'"></Translate></small>
								<span v-if="voce.FLG_ESCLUDI_TOTALE_VENDITA == 1" class="text-muted">-</span>
								<span v-else-if="voce.FLG_OMAGGIO_UNIT_PRICE == 1 || voce.FLG_OMAGGIO_TOTAL_PRICE == 1" class="badge bg-primary bg-opacity-20 text-primary" style="font-size:0.65rem;"><Translate :path="'dizionario.attivita.OMAGGIO'"></Translate></span>
								<template v-else>
									<span class="text-primary fw-semibold">&euro; {{ filters.formattaImporto(totalePrezzoMostrato) }}</span>
									<span v-if="ivaCode" class="badge bg-secondary ms-1" style="font-size:0.65rem;" :title="ivaCode.DESCRIZIONE">{{ ivaCode.CUSTOM_1 }}</span>
								</template>
							</div>
							<div class="col-6">
								<small class="text-muted d-block"><Translate :path="'dizionario.attivita.COSTO_UNIT'"></Translate></small>
								<span v-if="voce.FLG_OMAGGIO_UNIT_COST_ESPOSTO == 1" class="badge bg-danger bg-opacity-20 text-danger" style="font-size:0.65rem;"><Translate :path="'dizionario.attivita.OMAGGIO'"></Translate></span>
								<span v-else>&euro; {{ filters.formattaImporto(voce.UNIT_COST_ESPOSTO) }}</span>
							</div>
							<div class="col-6">
								<small class="text-muted d-block"><Translate :path="'dizionario.attivita.COSTI'"></Translate></small>
								<span v-if="voce.FLG_ESCLUDI_TOTALE_ACQUISTO == 1" class="text-muted">-</span>
								<span v-else-if="voce.FLG_OMAGGIO_UNIT_COST_ESPOSTO == 1" class="badge bg-danger bg-opacity-20 text-danger" style="font-size:0.65rem;"><Translate :path="'dizionario.attivita.OMAGGIO'"></Translate></span>
								<template v-else>
									<span class="text-danger fw-semibold">&euro; {{ filters.formattaImporto(totaleCostoMostrato) }}</span>
									<span v-if="ivaCodiceAcquisto" class="badge bg-secondary ms-1" style="font-size:0.65rem;" :title="ivaCodiceAcquisto.DESCRIZIONE">{{ ivaCodiceAcquisto.CUSTOM_1 }}</span>
								</template>
							</div>
							<div class="col-6">
								<small class="text-muted d-block"><Translate :path="'dizionario.attivita.COMMISSIONI'"></Translate></small>
								<span v-if="voce.FLG_ESCLUDI_TOTALE_ACQUISTO == 1" class="text-muted">-</span>
								<span v-else-if="voce.FLG_OMAGGIO_TOTAL_COST_PRIVATO == 1" class="badge bg-warning bg-opacity-20 text-warning" style="font-size:0.65rem;"><Translate :path="'dizionario.attivita.OMAGGIO'"></Translate></span>
								<template v-else>
									<span class="text-warning fw-semibold">&euro; {{ filters.formattaImporto(totaleCommissioniMostrato) }}</span>
									<span v-if="ivaCodiceCommissioni" class="badge bg-secondary ms-1" style="font-size:0.65rem;" :title="ivaCodiceCommissioni.DESCRIZIONE">{{ ivaCodiceCommissioni.CUSTOM_1 }}</span>
								</template>
							</div>
							<div class="col-6">
								<small class="text-muted d-block"><Translate :path="'dizionario.base.FORNITORE'"></Translate></small>
								<span v-if="voce.FORNITORE_ALIAS">{{ filters.accorciaTesto(voce.FORNITORE_ALIAS, 50) }}<span v-if="voce.IMPORTO_FATTURATO > 0" class="badge ms-1" style="font-size:0.65rem; letter-spacing:0;" :class="percFatturata >= 100 ? 'bg-success' : 'bg-warning text-dark'" :title="'Fatturato € ' + filters.formattaImporto(voce.IMPORTO_FATTURATO) + ' su € ' + filters.formattaImporto(importoAcquisto)">F {{ percFatturata }}%</span></span>
								<span v-else class="text-muted fst-italic">-</span>
							</div>
						</div>
					</div>
				</div>
			</td>
		</template>
	</tr>
</template>

<script>
import { useDropdownManager } from '@/composables/useDropdownManager.js'
import Translate from '@/components/utils/Translate.vue'
import { ref } from 'vue'
import DOMPurify from 'dompurify'

// Il titolo voce arriva da CKEditor: si interpreta come HTML ma solo con i tag
// di formattazione previsti dall'editor, rimuovendo script, eventi e URL pericolosi.
const TITOLO_HTML_TAGS = [
	'p', 'div', 'br', 'strong', 'b', 'em', 'i', 'u', 's', 'strike', 'del',
	'ul', 'ol', 'li', 'a', 'span', 'blockquote', 'sub', 'sup',
	'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
]

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
	if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
		node.setAttribute('rel', 'noopener noreferrer')
	}
})

export default {
	name: 'VoceNode',

	components: {
		/* ISwitch, */
		Translate,
	},

	props: {
		voce: {
			type: Object,
			required: true,
		},
		depth: {
			type: Number,
			default: 0,
		},
		attivita: {
			type: Object,
			required: true,
		},
		readOnly: {
			type: Boolean,
			default: false,
		},
		dragEnabled: {
			type: Boolean,
			default: true,
		},
		showIva: {
			type: Boolean,
			default: false,
		},
	},

	emits: ['refresh', 'apri-azioni-voce'],

	setup() {
		const dropdownManager = useDropdownManager();
		const dropdownId = ref(null);
		const dropdownOpen = ref(false);
		const dropdownStyle = ref({});
		const dropdownToggle = ref(null);

		return {
			dropdownManager,
			dropdownId,
			dropdownOpen,
			dropdownStyle,
			dropdownToggle,
		};
	},

	data() {
		return {
			filters: global.filters,
			utils: global.utils,
			titleExpanded: false,
			isTitleTruncated: false,
			mobileDetailExpanded: false,
			editingField: null,
			editingValue: '',
		}
	},

	computed: {
		titoloVoceHtml() {
			if (!this.voce.TITOLO_VOCE) return '';
			return DOMPurify.sanitize(String(this.voce.TITOLO_VOCE), {
				ALLOWED_TAGS: TITOLO_HTML_TAGS,
				ALLOWED_ATTR: ['href', 'title', 'target', 'rel'],
				ALLOW_DATA_ATTR: false,
			});
		},

		canEditInline() {
			return !this.readOnly && this.voce.FLG_ELIMINATO != 1 &&
				(this.$root.isGod || this.$root.hasFunzionalita('VOCE_UPDATE'));
		},

		ivaCode() {
			return this.filters.getIvaCodeById(this.voce.FK_ID_IVA_PREZZO);
		},

		ivaCodiceAcquisto() {
			return this.filters.getIvaCodeById(this.voce.FK_ID_IVA_COSTO);
		},

		ivaCodiceCommissioni() {
			return this.filters.getIvaCodeById(this.voce.FK_ID_IVA_COMMISSIONI);
		},

		totalePrezzoMostrato() {
			const base = parseFloat(this.voce.TOTAL_PRICE) || 0;
			const importo = this.filters.calcolaImportoIva(base, this.ivaCode);
			return (this.showIva && importo > 0 && this.voce.FLG_NETTO_IVA_VENDITA != 1) ? (base + importo).toFixed(2) : this.voce.TOTAL_PRICE;
		},

		totaleCostoMostrato() {
			const base = parseFloat(this.voce.TOTAL_COST_ESPOSTO) || 0;
			const importo = this.filters.calcolaImportoIva(base, this.ivaCodiceAcquisto);
			return (this.showIva && importo > 0 && this.voce.FLG_NETTO_IVA_ACQUISTO != 1) ? (base + importo).toFixed(2) : this.voce.TOTAL_COST_ESPOSTO;
		},

		importoAcquisto() {
			return this.filters.importoAcquistoVoce(this.voce);
		},

		percFatturata() {
			return this.importoAcquisto > 0 ? Math.round(parseFloat(this.voce.IMPORTO_FATTURATO) / this.importoAcquisto * 100) : 0;
		},

		totaleCommissioniMostrato() {
			const base = parseFloat(this.voce.TOTAL_COST_PRIVATO) || 0;
			const importo = this.filters.calcolaImportoIva(base, this.ivaCodiceCommissioni);
			return (this.showIva && importo > 0 && this.voce.FLG_NETTO_IVA_COMMISSIONI != 1) ? (base + importo).toFixed(2) : this.voce.TOTAL_COST_PRIVATO;
		},
	},

	mounted() {
		// Registra questo dropdown nel sistema centralizzato
		this.dropdownId = this.dropdownManager.registerDropdown(() => {
			this.closeDropdown();
		});

		// Gestisci click fuori dal dropdown per chiuderlo
		document.addEventListener('click', this.handleOutsideClick);

		// Il titolo è troncato dal CSS: misura l'overflow reale e ricalcola al resize
		this.titoloObserver = new ResizeObserver(() => this.checkTitleTruncated());
		if (this.$refs.titolo) this.titoloObserver.observe(this.$refs.titolo);
	},

	watch: {
		'voce.TITOLO_VOCE'() {
			this.$nextTick(this.checkTitleTruncated);
		},
	},

	beforeUnmount() {
		if (this.titoloObserver) this.titoloObserver.disconnect();
		// Pulisci il dropdown dal registro
		if (this.dropdownId) {
			this.dropdownManager.unregisterDropdown(this.dropdownId);
		}
		document.removeEventListener('click', this.handleOutsideClick);
	},

	methods: {
		checkTitleTruncated() {
			// Da espanso non c'è overflow da misurare: si mantiene lo stato precedente
			if (this.titleExpanded) return;
			const el = this.$refs.titolo;
			this.isTitleTruncated = !!el && el.scrollWidth > el.clientWidth;
		},

		toggleDropdown() {
			if (this.dropdownOpen) {
				this.closeDropdown();
			} else {
				this.openDropdown();
			}
		},

		openDropdown() {
			// Notifica il manager per chiudere altri dropdown
			this.dropdownManager.openDropdown(this.dropdownId);
			this.dropdownOpen = true;

			// Calcola la posizione del dropdown
			this.$nextTick(() => {
				this.updateDropdownPosition();
			});
		},

		closeDropdown() {
			this.dropdownOpen = false;
			this.dropdownManager.closeDropdown(this.dropdownId);
		},

		updateDropdownPosition() {
			if (!this.$refs.dropdownToggle) return;

			const toggle = this.$refs.dropdownToggle;
			const rect = toggle.getBoundingClientRect();
			const dropdownWidth = 200; // Larghezza approssimativa del dropdown
			const padding = 10; // Padding dal bordo della viewport

			// Calcola la posizione a destra (align-end)
			let leftPos = rect.left - dropdownWidth + toggle.offsetWidth;

			// Verifica se il dropdown esce dal viewport a destra
			if (leftPos + dropdownWidth + padding > window.innerWidth) {
				// Se esce, posiziona dalla parte opposta
				leftPos = rect.left - (dropdownWidth - toggle.offsetWidth) - padding;
				// Se comunque non entra, usa il minimo necessario
				if (leftPos < padding) {
					leftPos = padding;
				}
			}

			// Assicura che non esce dal lato sinistro
			if (leftPos < padding) {
				leftPos = padding;
			}

			this.dropdownStyle = {
				position: 'fixed',
				top: `${rect.bottom + 2}px`,
				left: `${leftPos}px`,
				zIndex: '99999',
				maxWidth: 'calc(100vw - 20px)', // Evita che il dropdown sia più largo della viewport
			};
		},

		handleOutsideClick(event) {
			if (!this.dropdownOpen) return;

			const dropdownEl = this.$refs.dropdownEl;
			const toggle = this.$refs.dropdownToggle;

			if (dropdownEl && !dropdownEl.contains(event.target) &&
			    toggle && !toggle.contains(event.target)) {
				this.closeDropdown();
			}
		},

		handleMenuClick(event) {
			// Previeni la propagazione del click per evitare che chiuda il dropdown prematuramente
			event.stopPropagation();
		},

		updateFlgDaCalcolareVoce(newFlagValue) {
			utils.put('theb/voce/update', {
				ID_VOCE: this.voce.ID_VOCE,
				TITOLO: this.voce.TITOLO_VOCE,
				FLG_DA_CALCOLARE: newFlagValue,
			}, (response) => {
				if (response.esito == 0) {
					this.$emit('refresh');
				}
			});
		},

		toggleFlgAttivoVoce(newFlagValue) {
			utils.put('theb/voce/update', {
				ID_VOCE: this.voce.ID_VOCE,
				TITOLO: this.voce.TITOLO_VOCE,
				FLG_ATTIVO: newFlagValue,
			}, (response) => {
				if (response.esito == 0) {
					this.$emit('refresh');
				}
			});
		},

		startEditCampo(field, value, disabled) {
			if (!this.canEditInline || disabled) return;
			this.editingField = field;
			this.editingValue = value;
			this.$nextTick(() => {
				if (this.$refs.inlineInput) {
					this.$refs.inlineInput.focus();
					this.$refs.inlineInput.select();
				}
			});
		},

		annullaEditCampo() {
			this.editingField = null;
		},

		confermaEditCampo() {
			if (!this.editingField) return;
			const field = this.editingField;

			if (field == 'QUANTITY_PRICE' || field == 'DAYS_PRICE') {
				const intVal = parseInt(this.editingValue);
				if (!intVal || intVal < 1) {
					utils.alert.warning('Il valore deve essere almeno 1');
					return;
				}
				this.salvaCampoQuantitaGiorni(field, intVal);
			} else {
				const floatVal = parseFloat(this.editingValue) || 0;
				if (floatVal < 0) {
					utils.alert.warning('Il valore non può essere negativo');
					return;
				}
				this.salvaCampoImporto(field, floatVal);
			}
		},

		salvaCampoQuantitaGiorni(field, intVal) {
			const quantityPrice = field == 'QUANTITY_PRICE' ? intVal : (parseInt(this.voce.QUANTITY_PRICE) || 1);
			const daysPrice = field == 'DAYS_PRICE' ? intVal : (parseInt(this.voce.DAYS_PRICE) || 1);
			const unitPrice = parseFloat(this.voce.UNIT_PRICE) || 0;
			const unitCostEsposto = parseFloat(this.voce.UNIT_COST_ESPOSTO) || 0;

			utils.put('theb/voce/update', {
				ID_VOCE: this.voce.ID_VOCE,
				TITOLO: this.voce.TITOLO_VOCE,
				QUANTITY_PRICE: quantityPrice,
				DAYS_PRICE: daysPrice,
				QUANTITY_COST_ESPOSTO: quantityPrice,
				DAYS_COST_ESPOSTO: daysPrice,
				TOTAL_PRICE: (unitPrice * quantityPrice * daysPrice).toFixed(2),
				TOTAL_COST_ESPOSTO: (unitCostEsposto * quantityPrice * daysPrice).toFixed(2),
			}, (response) => {
				this.editingField = null;
				if (response.esito == 0) {
					this.$emit('refresh');
				}
			});
		},

		salvaCampoImporto(field, floatVal) {
			const payload = {
				ID_VOCE: this.voce.ID_VOCE,
				TITOLO: this.voce.TITOLO_VOCE,
			};

			if (field == 'UNIT_PRICE') {
				const quantity = parseInt(this.voce.QUANTITY_PRICE) || 1;
				const days = parseInt(this.voce.DAYS_PRICE) || 1;
				payload.UNIT_PRICE = floatVal.toFixed(2);
				payload.TOTAL_PRICE = (floatVal * quantity * days).toFixed(2);
			} else if (field == 'UNIT_COST_ESPOSTO') {
				const quantity = parseInt(this.voce.QUANTITY_COST_ESPOSTO) || 1;
				const days = parseInt(this.voce.DAYS_COST_ESPOSTO) || 1;
				payload.UNIT_COST_ESPOSTO = floatVal.toFixed(2);
				payload.TOTAL_COST_ESPOSTO = (floatVal * quantity * days).toFixed(2);
			} else if (field == 'TOTAL_COST_PRIVATO') {
				payload.TOTAL_COST_PRIVATO = floatVal.toFixed(2);
			}

			utils.put('theb/voce/update', payload, (response) => {
				this.editingField = null;
				if (response.esito == 0) {
					this.$emit('refresh');
				}
			});
		},
	},
}
</script>

<style scoped>
/* A consuntivo ma mostrata nell'albero del preventivo: visibile, fuori dai totali */
.fuori-preventivo > td { opacity: 0.55; font-style: italic; }

/* Drag Handle */
.drag-handle-voce {
	opacity: 0.4;
	transition: opacity 0.2s;
}

.drag-handle-voce:hover {
	opacity: 1;
}

/* Voce Row */
tr {
	transition: background-color 0.2s ease;
	position: relative;
}

tr:hover {
	background-color: rgba(0, 0, 0, 0.02) !important;
}

/* Fix dropdown in table */
.actions-cell {
	position: static;
}

.dropdown {
	position: relative;
}

/* Colori bordi laterali per le celle della voce */
.voce-cell {
	text-align: right;
}

.voce-cell-index {
	text-align: center;
}

.voce-cell-vendita {
	text-align: left;
}

.voce-cell-vendita:not(:first-of-type) {
	text-align: right;
}

.voce-cell-acquisto {
	text-align: right;
}

.voce-cell-fornitore {
	text-align: right;
}

.voce-cell-actions {
	text-align: center;
}

.inline-editable {
	cursor: text;
}

.inline-editable:hover {
	background-color: rgba(0, 0, 0, 0.04);
}

.inline-edit-input {
	width: 100%;
	text-align: right;
	padding: 0.1rem 0.3rem;
	height: auto;
}

/* Mobile card */
.voce-mobile-cell {
	text-align: left;
}

.voce-mobile-row {
	cursor: pointer;
}

.voce-mobile-details {
	background-color: rgba(0, 0, 0, 0.02);
	border-top: 1px solid #e8e8e8;
	font-size: 0.8rem;
}

.min-w-0 {
	min-width: 0;
}

/* Titolo voce: HTML formattato da CKEditor, confinato nella cella.
   I margini dei paragrafi sono azzerati per non alterare l'altezza delle righe. */
.voce-titolo-html {
	min-width: 0;
	overflow-wrap: anywhere;
}

.voce-titolo-html :deep(p),
.voce-titolo-html :deep(div),
.voce-titolo-html :deep(blockquote),
.voce-titolo-html :deep(h1),
.voce-titolo-html :deep(h2),
.voce-titolo-html :deep(h3),
.voce-titolo-html :deep(h4),
.voce-titolo-html :deep(h5),
.voce-titolo-html :deep(h6) {
	margin: 0;
}

.voce-titolo-html :deep(h1),
.voce-titolo-html :deep(h2),
.voce-titolo-html :deep(h3),
.voce-titolo-html :deep(h4),
.voce-titolo-html :deep(h5),
.voce-titolo-html :deep(h6) {
	font-size: inherit;
	font-weight: 600;
}

.voce-titolo-html :deep(ul),
.voce-titolo-html :deep(ol) {
	margin: 0;
	padding-left: 1.25rem;
}

.voce-titolo-html :deep(li) {
	margin: 0;
}

.voce-titolo-html :deep(a) {
	color: inherit;
	text-decoration: underline;
}

/* Collassato: una sola riga con ellissi come prima, senza che i blocchi HTML
   facciano crescere la riga della tabella. */
.voce-titolo-html.is-collapsed {
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}

.voce-titolo-html.is-collapsed :deep(p),
.voce-titolo-html.is-collapsed :deep(div),
.voce-titolo-html.is-collapsed :deep(blockquote),
.voce-titolo-html.is-collapsed :deep(h1),
.voce-titolo-html.is-collapsed :deep(h2),
.voce-titolo-html.is-collapsed :deep(h3),
.voce-titolo-html.is-collapsed :deep(h4),
.voce-titolo-html.is-collapsed :deep(h5),
.voce-titolo-html.is-collapsed :deep(h6) {
	display: inline;
}

.voce-titolo-html.is-collapsed :deep(br) {
	display: none;
}

.voce-titolo-html.is-collapsed :deep(ul),
.voce-titolo-html.is-collapsed :deep(ol) {
	display: inline;
	margin: 0;
	padding: 0;
}

.voce-titolo-html.is-collapsed :deep(li) {
	display: inline;
}

.voce-titolo-html.is-collapsed :deep(ul > li)::before {
	content: "• ";
}

.voce-titolo-html.is-collapsed :deep(ol) {
	counter-reset: voce-titolo-ol;
}

.voce-titolo-html.is-collapsed :deep(ol > li) {
	counter-increment: voce-titolo-ol;
}

.voce-titolo-html.is-collapsed :deep(ol > li)::before {
	content: counter(voce-titolo-ol) ". ";
}

</style>
